import script from "./SofortPop.vue?vue&type=script&setup=true&lang=js"
export * from "./SofortPop.vue?vue&type=script&setup=true&lang=js"

import "./SofortPop.vue?vue&type=style&index=0&id=1f4cfea0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4cfea0"]])

export default __exports__